import { CreateInitiative } from '@ui/initiatives';
import { GearLinkSection } from './GearLinkSection';
import { LabeledValue } from 'antd/es/select';
import { OptionFilter } from '@periscopes/general/filters';
import { PostInitiativeResponse } from '@sonar-software/sonar-core';
import { useInitiatives } from '@hooks';

import { COPY_GENERIC, COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { memo, useCallback, useMemo, useState } from 'react';

export interface InitativeSelectorProps {
	onChange: (option: LabeledValue) => void;
	value?: LabeledValue;
}

export const InitiativeSelector: React.FC<InitativeSelectorProps> = memo(({ onChange, value }) => {
	const { data, request } = useInitiatives(true);
	const [ open, setOpen ] = useState<boolean>();

	const options = useMemo(
		() => data.results.map((initiative) => ({
			label: initiative.title,
			value: initiative.id
		})) ?? [],
		[ data?.results ]
	);

	const onSearch = useCallback((query: string) => {
		request({
			...useInitiatives.defaultRequest,
			title: query
		});
	}, [ request ]);

	const handleOnFinish = useCallback((initiative: PostInitiativeResponse) => {
		setOpen(false);
		setTimeout(() => setOpen(undefined));

		onChange({
			label: initiative.initiativeTitle,
			value: initiative.initiativeId
		});
	}, [ onChange ]);

	return (
		<GearLinkSection route={ FULL_ROUTES.INITIATIVES }>
			<OptionFilter
				labelInValue
				onChange={ onChange }
				onSearch={ onSearch }
				open={ open }
				options={ options }
				placeholder={ COPY_GENERIC.SELECT(COPY_SPECIFIC.INITIATIVE) }
				popupRender={
					(menu) =>
						<>
							{ menu }
							<CreateInitiative
								onFinish={ handleOnFinish }
								source='card' />
						</>
				}
				value={ value } />
		</GearLinkSection>
	);
});
